import type {
  DefaultQueryParams,
  QueryParams,
} from '@/modules/common/context/QueryParams/models';
import type {Page} from '@/types';

import {
  config,
  defaultSearchParamsByTravelType,
  defaultTravelType,
} from '@/config';

export const getDefaultValues = ({
  travelType,
  currentPage,
}: {
  travelType: QueryParams['travelType'];
  currentPage: Page;
}): DefaultQueryParams => {
  const defaultSearchParams =
    defaultSearchParamsByTravelType[travelType ?? defaultTravelType];
  const sortBy = config.sorting.defaultByPage[currentPage];

  return {
    ...defaultSearchParams,
    sortBy,
  };
};
